import React from 'react';
import { LeftContainerHeaderType } from '../types';
import { useStyletron } from '../../../Themes';
import { TooltipButton } from './TooltipButton';
import Logo from './Logo';
import Title from './Title';

const HeaderSubContainerLeft = ({ className, ...props }: any) => {
    const [css]: any = useStyletron();

    const basicClassname = `${css({
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        flex: 1,
    })}`;
    const headerLeftSubContainer = className ? `${className} ${basicClassname}` : basicClassname;

    return (
        <section
            {...props}
            aria-label="header section left" // todo-a11y: dynamic labeling?
            className={headerLeftSubContainer}
        ></section>
    );
};

function LeftContainer(props: LeftContainerHeaderType) {
    const {
        leftLayout,
        hamburgerMenu,
        epoLogo,
        size = 0,
        neutralLogo,
        productName,
        onHamburgerMenu,
        onClickEpoLogo,
        epoLogoSrcPath,
        epoLogoTargetUrl,
        onClickProductName
    } = props;

    return <HeaderSubContainerLeft>
        {/* Hamburger menu should only shown in tablet & mobile */}
        {hamburgerMenu && size <= 960 && (
            <TooltipButton
                icon="menu"
                tooltip="menu"
                ariaLabel="open/close menu" // a11y-todo: fixed name vs dynamic label (depends on what´s inside)
                onClickTooltipButton={onHamburgerMenu}
            />
        )}
        {epoLogo && (
            <Logo
                onClickEpoLogo={onClickEpoLogo}
                srcPath={epoLogoSrcPath}
                targetUrl={epoLogoTargetUrl}
            />
        )}
        {neutralLogo}
        {productName && <Title onClickProductName={onClickProductName}>{productName}</Title>}
        {leftLayout}
    </HeaderSubContainerLeft>
}

export default LeftContainer;